/**
 * Suppresses console.log and console.debug in production/staging environments.
 * Must be imported as early as possible (side-effect import).
 *
 * Environments where logs ARE shown: dev-*, sit, ci, local (empty string)
 * Environments where logs are SUPPRESSED: stg, prd, poc
 */
const env = (process.env.ENVIRONMENT || "").toLowerCase();
const isDevEnvironment =
      env === "" || env.includes("dev") || env.includes("sit") || env.includes("ci") || env.includes("poc");

if (!isDevEnvironment) {
      const noop = () => {};
      console.log = noop;
      console.debug = noop;
}
